import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';
import { createPrebuiltHeaderPromoAttributes, createPrebuiltHeaderSubcatPromoAttributes } from '../header-promo-attrs';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { PrebuiltCategoryHeaderData } from 'JS/dxp/types/widgets/prebuilt-header-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'CatHeader',
  props: {
    data: null
  },
  setup(__props: any) {



const title = "Cat Supplies";
const subtitle = "Shop online or in-store for affordable cat supplies. Find cat food, cat treats, cat grooming, cat toys, cat litter, cat carriers and more!";

const image = "url('/assets/images/dxp/prebuilt-headers/Cat-Hero.jpg')";

const gaDataAttributes = createPrebuiltHeaderPromoAttributes(title, subtitle);


return { __sfc: true,title, subtitle, image, gaDataAttributes, UiButton, createPrebuiltHeaderSubcatPromoAttributes, cssVarsToStyleString }
}

})